import { PDFViewer, Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import React from 'react';
import assets from '../../assets';

Font.register({
  family: 'Source Sans Pro',
  src: require('../../assets/fonts/source-sans-pro.ttf'),
});
Font.register({
  family: 'Source Sans Bold',
  src: require('../../assets/fonts/source-sans-pro.bold.ttf'),
});
Font.register({
  family: 'Source Sans SemiBold',
  src: require('../../assets/fonts/source-sans-pro.semibold.ttf'),
});

const styles = StyleSheet.create({
  body: {},
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
  title: {
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Source Sans Bold',
    color: '#136033',
  },
  validade: {
    fontSize: 8,
    textAlign: 'center',
    color: '#B8B8B8',
  },
  subtitle: {
    fontSize: 9,
    textAlign: 'center',
    paddingTop: 6,
    color: '#136033',
    fontFamily: 'Source Sans SemiBold',
    width: 137,
    height: 24,
    backgroundColor: '#FAFAFA',
    borderBottomRightRadius: 20,
  },
  proposta: {
    fontSize: 14,
    textAlign: 'right',
  },
  observacoes: {
    fontSize: 9,
    width: 311,
    height: 85,
    textAlign: 'left',
    backgroundColor: '#FAFAFA',
    borderRadius: 4,
    color: '#7E7E7E',
    paddingTop: 14,
    paddingLeft: 10,
    paddingRight: 10,
    marginLeft: 32,
    marginTop: 11,
  },
  text: {
    fontSize: 9,
    textAlign: 'justify',
    color: '#7E7E7E',
    fontFamily: 'Times-Roman',
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 12,
    width: '100%',
    marginBottom: 20,
    backgroundColor: '#F5F5F5',
    height: 80,
    borderBottom: 'solid',
    borderColor: '#E0E0E0',
    borderBottomWidth: 1,
    textAlign: 'center',
  },
  headerImage: {
    width: 110,
    height: 48,
    paddingRight: 26,
    marginLeft: 32,
    borderRight: 'solid',
    borderColor: '#A5CD39',
    borderRightWidth: 1,
  },
  blocoValores: {
    backgroundColor: '#FAFAFA',
    width: 211,
    marginLeft: 9,
    height: 88,
    borderRadius: 4,
    paddingLeft: 12,
    paddingTop: 20,
  },
  condicoes: {
    backgroundColor: '#FAFAFA',
    width: 211,
    marginTop: 9,
    height: 88,
    borderRadius: 4,
    paddingLeft: 12,
    paddingTop: 20,
  },
  blocoText: {
    marginLeft: 32,
    marginTop: 8,
    marginBottom: 16,
  },
  valorTotal: {
    backgroundColor: '#136033',
    height: 32,
    fontSize: 14,
    marginLeft: 9,
    fontFamily: 'Source Sans Bold',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    color: '#FAFAFA',
    paddingTop: 6,
    paddingLeft: 12,
  },
  headerText: {
    display: 'flex',
    fontFamily: 'Source Sans Pro',
    fontSize: 8,
    width: 185,
    color: '#585858',
    textAlign: 'left',
    flexDirection: 'column',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  table: {
    display: 'flex',
    width: '100%',
    marginTop: 8,
    paddingLeft: 10,
    paddingRight: 20,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCellTitulos: {
    margin: 'auto',
    marginTop: 5,
    color: '#7E7E7E',
    fontSize: 8,
  },
  tableCellProduto: {
    margin: 'auto',
    marginTop: 5,
    color: '#136033',
    fontSize: 8,
    fontFamily: 'Source Sans SemiBold',
  },
  tableCol: {
    width: '8.5%',
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
  },
});

const Table = ({}) => {
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellTitulos}>SKU</Text>
        </View>
        <View style={{ width: '40%' }}>
          <Text style={styles.tableCellTitulos}>Produto</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellTitulos}>Qtde</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellTitulos}>Vlr unitário</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellTitulos}>%IPI</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellTitulos}>Vlr IPI</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellTitulos}>Vlr total</Text>
        </View>
      </View>
      <View style={styles.tableRow}>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellProduto}>868</Text>
        </View>
        <View style={{ width: '40%' }}>
          <Text style={styles.tableCellProduto}>Brinco grande eletrônico UHF laranja AB gravado</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellProduto}>5000</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellProduto}>R$ 46,68</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellProduto}>6,5%</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellProduto}>R$ 2.057,34</Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCellProduto}>R$ 31.605,00</Text>
        </View>
      </View>
    </View>
  );
};

const Vendedor = ({}) => {
  return (
    <View style={[styles.text, styles.blocoText, { display: 'flex', flexDirection: 'row', gap: '10px' }]}>
      <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Text>Nome: Fulano de Tal</Text>
        <Text>E-mail: email@teste.com</Text>
        <Text>Telefone: (54) 9 9999-9999</Text>
      </View>
    </View>
  );
};

const Cliente = ({}) => {
  return (
    <View style={[styles.text, styles.blocoText, { display: 'flex', flexDirection: 'row', gap: '10px' }]}>
      <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Text>Cliente: Fulano de Tal</Text>
        <Text>E-mail: email@teste.com</Text>
        <Text>Telefone: (54) 9 9999-9999</Text>
        <Text>Endereço: Lorem Ipsum</Text>
      </View>
    </View>
  );
};

function BasicDocument() {
  return (
    <div>
      <h1>PDF Viewer</h1>
      <PDFViewer style={styles.viewer}>
        <Document>
          <Page style={styles.body}>
            <View style={styles.header} fixed>
              <Image style={styles.headerImage} src={assets.images.logoPDF} />
              <View style={styles.headerText}>
                <Text>Primaza Termoplástico LTDA | CNPJ: 06.350.668/0001-45</Text>
                <Text>Av. Presidente Kennedy, 3400 | Panambi-RS | 98280-000</Text>
              </View>
              <View style={styles.headerText}>
                <Text>Fone: (55) 3375-8443 / (55) 3375-8443</Text>
                <Text>marketing@primaza.com.br</Text>
              </View>
            </View>
            <Text style={styles.title}>Orçamento 325684</Text>
            <Text style={styles.validade}>Válido até 27.08</Text>
            <Text style={styles.subtitle}>Dados do Cliente</Text>
            <Cliente />
            <Text style={styles.subtitle}>Produtos</Text>
            <Table />
            <View style={[{ display: 'flex', flexDirection: 'row', marginTop: 22 }]}>
              <View>
                <Text style={styles.subtitle}>Observações:</Text>
                <Text style={styles.observacoes}>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book.
                </Text>
              </View>
              <View>
                <View style={styles.blocoValores}>
                  <Text style={[styles.text, { marginBottom: 2 }]}>Valor total Itens: R$ 34.075,00</Text>
                  <Text style={[styles.text, { marginBottom: 2 }]}>Valor IPI: R$ 2.057,34</Text>
                  <Text style={[styles.text, { marginBottom: 2 }]}>Valor Frete: R$ 50,00</Text>
                  <Text style={[styles.text, { marginBottom: 2 }]}>Valor do Desconto: R$ 10,00</Text>
                </View>
                <Text style={styles.valorTotal}>Total:{''} R$ 36.172,34 </Text>
              </View>
            </View>
            <View style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', marginRight: 32 }}>
              <View style={[styles.condicoes]}>
                <Text style={[styles.text, { marginBottom: 2 }]}>Condição de negociação</Text>
                <Text style={[styles.text, { marginBottom: 2 }]}>Boleto - 28 dias</Text>
                <Text style={[styles.text, { marginBottom: 2 }]}>A Vista - 3% desconto</Text>
                <Text style={[styles.text, { marginBottom: 2 }]}>Valor do Desconto: R$ 10,00</Text>
              </View>
            </View>
            <View style={styles.pageNumber}>
              <Text style={styles.subtitle}>Revendedor</Text>
              <Vendedor />
            </View>
            <View style={[styles.pageNumber, { backgroundColor: '#136033', height: 8, bottom: 0 }]}> </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}
export default BasicDocument;
